import { createSelector } from '@ngrx/store';

import { createSingleEntityStore, getSingleEntityActions } from '@core/ngrx-legacy';
import type { CandidateShareEntity } from '@core/sharing-container-types';

const { actions, namespace, selectors, reducer } = createSingleEntityStore<CandidateShareEntity>()(
  'candidate-share',
  {
    customActions: adapter => {
      const defaultActions = getSingleEntityActions(adapter);
      return {
        fetch: (state, payload: { candidateId: number }) => defaultActions.fetch(state),
        fetchSuccess: (state, payload: CandidateShareEntity & { id: number }) =>
          defaultActions.fetchSuccess(state, payload),
        revokeAccess: (state, payload: { userId: number; sharedAdminCount: number }) =>
          adapter.update(state, {
            sharedWith: state.data.sharedWith.filter(user => user.adminId !== payload.userId),
            sharedAdminCount: payload.sharedAdminCount,
          }),
        shareWithTeam: (state, payload: { sharedAdminCount: number }) =>
          adapter.update(state, {
            sharedAdminCount: payload.sharedAdminCount,
          }),
      };
    },
  },
);

type UsedActions = Pick<
  typeof actions,
  'fetch' | 'fetchSuccess' | 'fetchFailed' | 'revokeAccess' | 'shareWithTeam'
>;

export const getCandidateScope = (candidateId: number) => `candidate:${candidateId}`;
const CandidateShareActions = {
  ...(<UsedActions>actions),
};

const CandidateShareSelectors = {
  ...selectors,
  withActivePublicLinks: createSelector(selectors.data, data =>
    data === null
      ? null
      : {
          ...data,
          containers: data.containers.filter(container => container.active),
        },
  ),
};

export {
  CandidateShareActions,
  CandidateShareSelectors,
  namespace as CandidateShareNamespace,
  reducer as CandidateShareReducer,
};
